<template>
    <div class="left_panel design_studio_panel name_numbers_panel">
        <div class="name-number-container"> 
            <div class="styling-header">
            <h4 class="styling-title">Add Names & Numbers</h4>
            <button class="close-btn" @click="onCloseMenu()" title="Close">
                <img src="/maincss/images/tool_close.svg" alt="Close" />
            </button>
        </div>
        <div class="name_number_main">
 <NameNumberStyling
                :activeView="activeView"
                :addName="currentViewState.addName"
                :addNumber="currentViewState.addNumber"
                :nameSettings="currentViewState.nameSettings"
                :numberSettings="currentViewState.numberSettings"
                :vinylColorList="vinyl_color_list"
                :nameFees="name_fees"
                :numberFees="number_fees"
                :numberSizesList="number_sizes_list"
                @update:addName="onAddNameChange"
                @update:addNumber="onAddNumberChange"
                @update:nameSettings="onNameSettingsChange"
                @update:numberSettings="onNumberSettingsChange"
                @closeMenu="onCloseMenu('nn-tab')"
            />
            <NameNumberTable
                :entries="currentViewState.entries"
                :addName="currentViewState.addName"
                :addNumber="currentViewState.addNumber"
                :saveButtonText="saveButtonText"
                @update:entries="onEntriesChange"
                @clearAll="onClearAll"
                @save="onSave"
                @goToTeamUniform="goToTeamUniform"
                @entryBlur="onEntryBlur"
                @previewRow="previewEntryOnCanvas"
            />
        </div>
            <div class="table-footer">
            <div class="total-info">
                <span class="total-label"
                    >Total Personalized ({{ totalFilledCount }})</span
                >
                <span class="size-breakdown">{{ sizeBreakdownText }}</span>
            </div>
            <div class="action-buttons">
                <button
                    class="btn-team-uniform d-none"
                    @click="$emit('goToTeamUniform')"
                >
                    TEAM UNIFORM
                </button>
                <button class="btn-save" @click="onSave">
                    {{ saveButtonText }}
                </button>
            </div>
            <div class="helper-text">
                <ul>
                    <li>'YOUR NAME' and '00' are sample placeholders.</li>
                    <li>
                        Our artists will expertly place each name/number from
                        your list.
                    </li>
                    <li>Names/numbers may be screen printed or vinyl.</li>
                </ul>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
import { fabric } from "fabric";
import ApiService from "@/common/api.service";
import NameNumberStyling from "./NameNumberStyling.vue";
import NameNumberTable from "./NameNumberTable.vue";

// Shared across all locations: one table (entries) and one styling (nameSettings, numberSettings)
function createSharedNameSettings() {
    return {
        fontFamily: "Verdana",
        fontSize: "21",
        fontColor: "#000000",
        colorId: null,
        colorName: "Black",
        decor_upcharge: 0
    };
}
function createSharedNumberSettings() {
    return {
        fontFamily: "Verdana",
        fontSize: "96",
        fontColor: "#000000",
        colorId: null,
        colorName: "Black",
        decor_upcharge: 0
    };
}

export default {
    name: "NameAndNumber",
    components: { NameNumberStyling, NameNumberTable },
    props: [
        "canvasActiveObject",
        "selectedCheckbox",
        "frontCanvasTop",
        "frontCanvasLeft",
        "designBox",
        "adminOptions",
        "activeColorIndex",
        "activeGenderKey",
        "genderGroupsItems",
        "buildId"
    ],
    data() {
        var sharedNameSettings = createSharedNameSettings();
        var sharedNumberSettings = createSharedNumberSettings();
        var sharedEntries = [];
        return {
            activeView: "front",
            viewStates: {
                front: {
                    addName: false,
                    addNumber: false,
                    nameSettings: sharedNameSettings,
                    numberSettings: sharedNumberSettings,
                    entries: sharedEntries
                },
                back: {
                    addName: false,
                    addNumber: false,
                    nameSettings: sharedNameSettings,
                    numberSettings: sharedNumberSettings,
                    entries: sharedEntries
                },
                left: {
                    addName: false,
                    addNumber: false,
                    nameSettings: sharedNameSettings,
                    numberSettings: sharedNumberSettings,
                    entries: sharedEntries
                },
                right: {
                    addName: false,
                    addNumber: false,
                    nameSettings: sharedNameSettings,
                    numberSettings: sharedNumberSettings,
                    entries: sharedEntries
                }
            },
            vinyl_color_list: [],
            number_sizes_list: [
                { pixel_val: 40, size_number: 2 },
                { pixel_val: 56, size_number: 3 },
                { pixel_val: 64, size_number: 4 },
                { pixel_val: 96, size_number: 6 },
                { pixel_val: 128, size_number: 8 }
            ],
            name_fees: 0,
            number_fees: 0,
            product_category_id: "",
            sizeQuantities: [],
            isInitialized: false,
            /** Per-location: which row to show on canvas (eye click). Ek location change hone se doosri affect nahi hogi */
            previewEntryIndexByView: { front: null, back: null, left: null, right: null },
            /** Per-view AND per-row (entry) saved position+resize: har row ka apna position/size (e.g. Row 1 JS 23, Row 2 JINWNI 34 alag) */
            nameNumberPositionByView: {
                front: { byEntry: {} },
                back: { byEntry: {} },
                left: { byEntry: {} },
                right: { byEntry: {} }
            }
        };
    },
    computed: {
        currentViewState() {
            var def = {
                addName: false,
                addNumber: false,
                nameSettings: {
                    fontFamily: "Verdana",
                    fontSize: "21",
                    fontColor: "#000000",
                    colorId: null,
                    colorName: "Black",
                    decor_upcharge: 0
                },
                numberSettings: {
                    fontFamily: "Verdana",
                    fontSize: "96",
                    fontColor: "#000000",
                    colorId: null,
                    colorName: "Black",
                    decor_upcharge: 0
                },
                entries: []
            };
            if (!this.viewStates) return def;
            return (
                this.viewStates[this.activeView] || this.viewStates.front || def
            );
        },
        sizeBreakdown() {
            var b = {};
            (this.sizeQuantities || []).forEach(function (sq) {
                b[sq.size] = 0;
            });
            var entries = this.currentViewState && this.currentViewState.entries ? this.currentViewState.entries : [];
            var addName = this.currentViewState && this.currentViewState.addName;
            var addNumber = this.currentViewState && this.currentViewState.addNumber;
            entries.forEach(function (e) {
                var size = e && e.size;
                if (size == null) return;
                var filled = (addName && e.name && String(e.name).trim()) || (addNumber && e.number !== undefined && e.number !== null && String(e.number).trim());
                if (filled) {
                    if (b[size] === undefined) b[size] = 0;
                    b[size] += 1;
                }
            });
            return b;
        },
        // One row = one personalized item (name + number together count as one)
        totalFilledCount() {
            var b = this.sizeBreakdown || {};
            var sum = 0;
            for (var k in b) {
                if (b.hasOwnProperty(k) && b[k] > 0) sum += b[k];
            }
            return sum;
        },
        sizeBreakdownText() {
            var parts = [];
            var b = this.sizeBreakdown || {};
            for (var k in b) {
                if (b.hasOwnProperty(k) && b[k] > 0) {
                    parts.push(b[k] + " " + k);
                }
            }
            return parts.length ? parts.join(" | ") : "0 items";
        },
        saveButtonText() {
            return this.buildId ? "DONE" : "SAVE";
        },
        colorSizesForName() {
            var s = this.currentViewState && this.currentViewState.nameSettings;
            if (!s)
                return {
                    nameFontFamily: "Verdana",
                    nameFontColor: "#000000",
                    nameFontSize: "21",
                    color_id: null,
                    decor_upcharge: 0
                };
            return {
                nameFontFamily: s.fontFamily,
                nameFontColor: s.fontColor,
                nameFontSize: s.fontSize,
                color_id: s.colorId,
                decor_upcharge: s.decor_upcharge
            };
        },
        colorSizesForNumber() {
            var s =
                this.currentViewState && this.currentViewState.numberSettings;
            if (!s)
                return {
                    numberFontFamily: "Verdana",
                    numberFontColor: "#000000",
                    numberFontSize: "96",
                    color_id: null,
                    decor_upcharge: 0
                };
            return {
                numberFontFamily: s.fontFamily,
                numberFontColor: s.fontColor,
                numberFontSize: s.fontSize,
                color_id: s.colorId,
                decor_upcharge: s.decor_upcharge
            };
        },
        addInputName() {
            var v = this.currentViewState;
            return v && v.entries ? v.entries : [];
        },
        nameChecked() {
            var v = this.currentViewState;
            return v ? v.addName : false;
        },
        numberChecked() {
            var v = this.currentViewState;
            return v ? v.addNumber : false;
        },
        frontNameCount() {
            return this.countFilledEntries("front", "name");
        },
        frontNumberCount() {
            return this.countFilledEntries("front", "number");
        },
        backNameCount() {
            return this.countFilledEntries("back", "name");
        },
        backNumberCount() {
            return this.countFilledEntries("back", "number");
        },
        leftNameCount() {
            return this.countFilledEntries("left", "name");
        },
        leftNumberCount() {
            return this.countFilledEntries("left", "number");
        },
        rightNameCount() {
            return this.countFilledEntries("right", "name");
        },
        rightNumberCount() {
            return this.countFilledEntries("right", "number");
        },
        totalNamesCount() {
            return (
                this.frontNameCount +
                this.backNameCount +
                this.leftNameCount +
                this.rightNameCount
            );
        },
        totalNumbersCount() {
            return (
                this.frontNumberCount +
                this.backNumberCount +
                this.leftNumberCount +
                this.rightNumberCount
            );
        }
    },
    watch: {
        activeView: function (newView, oldView) {
            if (oldView && newView !== oldView) {
                var entryIdx = this.previewEntryIndexByView && this.previewEntryIndexByView[oldView];
                if (entryIdx != null) this.saveCurrentEntryPositionToView(oldView, entryIdx);
                this.saveViewToColor(oldView);
                this.updateCanvasFromEntries();
            }
        }
    },
    mounted() {
        this.initializeComponent();
    },
    methods: {
        initializeComponent() {
            var _this = this;
            this.getVinylColor().then(function () {
                _this.loadFeesFromAdminOptions();
                _this.loadSizeQuantities();
                _this.generateEntriesForAllViews();
                _this.loadFromColor();
                _this.syncActiveView();
                _this.setupCanvasWatcher();
                _this.isInitialized = true;
                _this.updateCanvasFromEntries();
            });
        },
        loadFeesFromAdminOptions() {
            if (!this.adminOptions) return;
            var nameObj = this.adminOptions.find(function (o) {
                return o.option_key === "name_fees";
            });
            var numObj = this.adminOptions.find(function (o) {
                return o.option_key === "number_fees";
            });
            if (nameObj) this.name_fees = parseFloat(nameObj.option_value || 0);
            if (numObj) this.number_fees = parseFloat(numObj.option_value || 0);
        },
        loadSizeQuantities() {
            var items = this.genderGroupsItems;
            if (!items || items.length === 0) return;
            var first = items[0];
            this.product_category_id =
                (first && first.item && first.item.category_id) || "";
            var idx = localStorage.getItem("colorIndex");
            var colors = first && first.colors && first.colors[idx];
            if (!colors || !colors.unique_sizes) return;
            var selected = colors.unique_sizes.filter(function (el) {
                return el.quantity > 0;
            });
            this.sizeQuantities = selected.map(function (ps) {
                return { size: ps.Size.size, qty: ps.quantity };
            });
        },
        generateEntriesForAllViews() {
            var entries = [];
            var id = 1;
            var _this = this;
            (this.sizeQuantities || []).forEach(function (sq) {
                for (var i = 0; i < sq.qty; i++) {
                    entries.push({
                        id: id,
                        name: "",
                        number: "",
                        size: sq.size,
                        visible: true
                    });
                    id++;
                }
            });
            // One shared table for all locations
            var sharedEntries = entries;
            ["front", "back", "left", "right"].forEach(function (view) {
                _this.$set(_this.viewStates[view], "entries", sharedEntries);
            });
        },
        syncActiveView() {
            var flip = localStorage.getItem("active_flip");
            if (flip && ["front", "back", "left", "right"].indexOf(flip) !== -1)
                this.activeView = flip;
        },
        setupCanvasWatcher() {
            var _this = this;
            this._canvasWatcher = setInterval(function () {
                var flip = localStorage.getItem("active_flip");
                if (flip && flip !== _this.activeView) {
                    _this.activeView = flip;
                    _this.loadFromColor();
                }
            }, 500);
        },
        getVinylColor() {
            var _this = this;
            return ApiService.get("/get-vinyl-colors")
                .then(function (res) {
                    var data = res.data;
                    _this.vinyl_color_list = data.color || [];
                    if (_this.vinyl_color_list.length > 0) {
                        var def = _this.vinyl_color_list[0];
                        // One shared styling for all locations
                        var newNameSettings = Object.assign(
                            {},
                            _this.viewStates.front.nameSettings,
                            { fontColor: def.hex, colorId: def.id, colorName: def.name }
                        );
                        var newNumberSettings = Object.assign(
                            {},
                            _this.viewStates.front.numberSettings,
                            { fontColor: def.hex, colorId: def.id, colorName: def.name }
                        );
                        ["front", "back", "left", "right"].forEach(function (view) {
                            _this.$set(_this.viewStates[view], "nameSettings", newNameSettings);
                            _this.$set(_this.viewStates[view], "numberSettings", newNumberSettings);
                        });
                    }
                })
                .catch(function () {});
        },
        loadFromColor() {
            var _this = this;
            var idx = localStorage.getItem("colorIndex");
            var group =
                this.genderGroupsItems &&
                this.genderGroupsItems[this.activeGenderKey];
            var color = group && group.colors && group.colors[idx];
            if (!color) return;

            // Only from name_and_number_json.selected_name_number (no fallback)
            var snn = (color.name_and_number_json && typeof color.name_and_number_json === "object" && color.name_and_number_json.selected_name_number)
                ? color.name_and_number_json.selected_name_number
                : null;
            if (snn) {
                ["front", "back", "left", "right"].forEach(function (view) {
                    if (snn[view]) {
                        _this.$set(
                            _this.viewStates[view],
                            "addName",
                            snn[view].name || false
                        );
                        _this.$set(
                            _this.viewStates[view],
                            "addNumber",
                            snn[view].number || false
                        );
                    }
                });
            }

            if (color.name_and_number_json) {
                var entriesData;
                if (Array.isArray(color.name_and_number_json)) {
                    entriesData = this.mergeEntriesWithExisting(
                        this.viewStates.front.entries,
                        color.name_and_number_json
                    );
                } else {
                    // Object: front/back/left/right arrays or selected_name_number
                    var src = color.name_and_number_json.front ||
                        color.name_and_number_json.back ||
                        color.name_and_number_json.left ||
                        color.name_and_number_json.right;
                    if (src && Array.isArray(src)) {
                        entriesData = this.mergeEntriesWithExisting(
                            this.viewStates.front.entries,
                            src
                        );
                    }
                }
                if (entriesData) {
                    ["front", "back", "left", "right"].forEach(function (view) {
                        _this.$set(_this.viewStates[view], "entries", entriesData);
                    });
                }
            }

            // One shared styling: load from first available view_settings
            if (
                color.view_settings &&
                typeof color.view_settings === "object"
            ) {
                var firstVs = color.view_settings.front ||
                    color.view_settings.back ||
                    color.view_settings.left ||
                    color.view_settings.right;
                if (firstVs) {
                    var newNameSettings = firstVs.nameSettings
                        ? Object.assign(
                            {},
                            _this.viewStates.front.nameSettings,
                            {
                                fontFamily: firstVs.nameSettings.fontFamily || "Verdana",
                                fontSize: firstVs.nameSettings.fontSize || "21",
                                fontColor: firstVs.nameSettings.fontColor || "#000000",
                                colorId: firstVs.nameSettings.colorId != null
                                    ? firstVs.nameSettings.colorId
                                    : firstVs.nameSettings.color_id,
                                colorName: firstVs.nameSettings.colorName || null,
                                decor_upcharge: firstVs.nameSettings.decor_upcharge || 0
                            }
                        )
                        : _this.viewStates.front.nameSettings;
                    var newNumberSettings = firstVs.numberSettings
                        ? Object.assign(
                            {},
                            _this.viewStates.front.numberSettings,
                            {
                                fontFamily: firstVs.numberSettings.fontFamily || "Verdana",
                                fontSize: firstVs.numberSettings.fontSize || "96",
                                fontColor: firstVs.numberSettings.fontColor || "#000000",
                                colorId: firstVs.numberSettings.colorId != null
                                    ? firstVs.numberSettings.colorId
                                    : firstVs.numberSettings.color_id,
                                colorName: firstVs.numberSettings.colorName || null,
                                decor_upcharge: firstVs.numberSettings.decor_upcharge || 0
                            }
                        )
                        : _this.viewStates.front.numberSettings;
                    ["front", "back", "left", "right"].forEach(function (view) {
                        _this.$set(_this.viewStates[view], "nameSettings", newNameSettings);
                        _this.$set(_this.viewStates[view], "numberSettings", newNumberSettings);
                    });
                }
            }
            // Fallback: legacy single font_color_sizes (apply to shared settings for all)
            if (
                color.font_color_sizes_name &&
                (!color.view_settings ||
                    !color.view_settings[this.activeView] ||
                    !color.view_settings[this.activeView].nameSettings)
            ) {
                var nameFromLegacy = Object.assign(
                    {},
                    this.viewStates.front.nameSettings,
                    {
                        fontFamily: color.font_color_sizes_name.nameFontFamily || "Verdana",
                        fontSize: color.font_color_sizes_name.nameFontSize || "21",
                        fontColor: color.font_color_sizes_name.nameFontColor || "#000000",
                        colorId: color.font_color_sizes_name.color_id || null,
                        decor_upcharge: color.font_color_sizes_name.decor_upcharge || 0
                    }
                );
                ["front", "back", "left", "right"].forEach(function (view) {
                    _this.$set(_this.viewStates[view], "nameSettings", nameFromLegacy);
                });
            }
            if (
                color.font_color_sizes_number &&
                (!color.view_settings ||
                    !color.view_settings[this.activeView] ||
                    !color.view_settings[this.activeView].numberSettings)
            ) {
                var numberFromLegacy = Object.assign(
                    {},
                    this.viewStates.front.numberSettings,
                    {
                        fontFamily: color.font_color_sizes_number.numberFontFamily || "Verdana",
                        fontSize: color.font_color_sizes_number.numberFontSize || "96",
                        fontColor: color.font_color_sizes_number.numberFontColor || "#000000",
                        colorId: color.font_color_sizes_number.color_id || null,
                        decor_upcharge: color.font_color_sizes_number.decor_upcharge || 0
                    }
                );
                ["front", "back", "left", "right"].forEach(function (view) {
                    _this.$set(_this.viewStates[view], "numberSettings", numberFromLegacy);
                });
            }
        },
        loadNameAndNumber(color, panelStep) {
            var _this = this;
            if (!color) return;
            this.syncActiveView();

            // Only from name_and_number_json.selected_name_number (no fallback)
            var snn = (color.name_and_number_json && typeof color.name_and_number_json === "object" && color.name_and_number_json.selected_name_number)
                ? color.name_and_number_json.selected_name_number
                : null;
            if (snn) {
                ["front", "back", "left", "right"].forEach(function (view) {
                    if (snn[view]) {
                        _this.$set(
                            _this.viewStates[view],
                            "addName",
                            snn[view].name || false
                        );
                        _this.$set(
                            _this.viewStates[view],
                            "addNumber",
                            snn[view].number || false
                        );
                    }
                });
            }

            if (color.name_and_number_json) {
                var entriesData;
                if (Array.isArray(color.name_and_number_json)) {
                    entriesData = this.mergeEntriesWithExisting(
                        this.viewStates.front.entries,
                        color.name_and_number_json
                    );
                } else {
                    var src = color.name_and_number_json.front ||
                        color.name_and_number_json.back ||
                        color.name_and_number_json.left ||
                        color.name_and_number_json.right;
                    if (src && Array.isArray(src)) {
                        entriesData = this.mergeEntriesWithExisting(
                            this.viewStates.front.entries,
                            src
                        );
                    }
                }
                if (entriesData) {
                    ["front", "back", "left", "right"].forEach(function (view) {
                        _this.$set(_this.viewStates[view], "entries", entriesData);
                    });
                }
            }

            // One shared styling from first available view_settings
            if (
                color.view_settings &&
                typeof color.view_settings === "object"
            ) {
                var firstVs = color.view_settings.front ||
                    color.view_settings.back ||
                    color.view_settings.left ||
                    color.view_settings.right;
                if (firstVs) {
                    var newNameSettings = firstVs.nameSettings
                        ? Object.assign(
                            {},
                            _this.viewStates.front.nameSettings,
                            {
                                fontFamily: firstVs.nameSettings.fontFamily || "Verdana",
                                fontSize: firstVs.nameSettings.fontSize || "21",
                                fontColor: firstVs.nameSettings.fontColor || "#000000",
                                colorId: firstVs.nameSettings.colorId != null
                                    ? firstVs.nameSettings.colorId
                                    : firstVs.nameSettings.color_id,
                                colorName: firstVs.nameSettings.colorName || null,
                                decor_upcharge: firstVs.nameSettings.decor_upcharge || 0
                            }
                        )
                        : _this.viewStates.front.nameSettings;
                    var newNumberSettings = firstVs.numberSettings
                        ? Object.assign(
                            {},
                            _this.viewStates.front.numberSettings,
                            {
                                fontFamily: firstVs.numberSettings.fontFamily || "Verdana",
                                fontSize: firstVs.numberSettings.fontSize || "96",
                                fontColor: firstVs.numberSettings.fontColor || "#000000",
                                colorId: firstVs.numberSettings.colorId != null
                                    ? firstVs.numberSettings.colorId
                                    : firstVs.numberSettings.color_id,
                                colorName: firstVs.numberSettings.colorName || null,
                                decor_upcharge: firstVs.numberSettings.decor_upcharge || 0
                            }
                        )
                        : _this.viewStates.front.numberSettings;
                    ["front", "back", "left", "right"].forEach(function (view) {
                        _this.$set(_this.viewStates[view], "nameSettings", newNameSettings);
                        _this.$set(_this.viewStates[view], "numberSettings", newNumberSettings);
                    });
                }
            }
            if (
                color.font_color_sizes_name &&
                (!color.view_settings ||
                    !color.view_settings[this.activeView] ||
                    !color.view_settings[this.activeView].nameSettings)
            ) {
                var nameFromLegacy = Object.assign(
                    {},
                    this.viewStates.front.nameSettings,
                    {
                        fontFamily: color.font_color_sizes_name.nameFontFamily || "Verdana",
                        fontSize: color.font_color_sizes_name.nameFontSize || "21",
                        fontColor: color.font_color_sizes_name.nameFontColor || "#000000",
                        colorId: color.font_color_sizes_name.color_id || null,
                        decor_upcharge: color.font_color_sizes_name.decor_upcharge || 0
                    }
                );
                ["front", "back", "left", "right"].forEach(function (view) {
                    _this.$set(_this.viewStates[view], "nameSettings", nameFromLegacy);
                });
            }
            if (
                color.font_color_sizes_number &&
                (!color.view_settings ||
                    !color.view_settings[this.activeView] ||
                    !color.view_settings[this.activeView].numberSettings)
            ) {
                var numberFromLegacy = Object.assign(
                    {},
                    this.viewStates.front.numberSettings,
                    {
                        fontFamily: color.font_color_sizes_number.numberFontFamily || "Verdana",
                        fontSize: color.font_color_sizes_number.numberFontSize || "96",
                        fontColor: color.font_color_sizes_number.numberFontColor || "#000000",
                        colorId: color.font_color_sizes_number.color_id || null,
                        decor_upcharge: color.font_color_sizes_number.decor_upcharge || 0
                    }
                );
                ["front", "back", "left", "right"].forEach(function (view) {
                    _this.$set(_this.viewStates[view], "numberSettings", numberFromLegacy);
                });
            }
            this.$forceUpdate();
        },
        mergeEntriesWithExisting(existing, loaded) {
            if (!loaded || loaded.length === 0) return existing || [];
            var existingList = existing || [];
            function numEqualsRowId(ld, index) {
                if (ld.number === undefined || ld.number === null) return false;
                var n = String(ld.number).trim();
                if (n === "") return false;
                var rowId = ld.id != null ? ld.id : index + 1;
                return n === String(rowId) || n === String(index + 1);
            }
            function getNumVal(ld, index) {
                var numVal = ld.number !== undefined && ld.number !== null ? ld.number.toString().trim() : "";
                if (numVal === "") return "";
                if (numEqualsRowId(ld, index) && !ld.numberUserEdited) return "";
                return numVal;
            }
            var result = existingList.map(function (entry, i) {
                var ld = loaded[i];
                if (!ld) return entry;
                var rowId = ld.id != null ? ld.id : entry.id;
                var numVal = getNumVal(ld, i);
                var nameVal = (ld.name != null ? ld.name : "").toString().trim();
                // Prefer existing name/number when loaded value is empty so user's unsaved input is not lost (e.g. on focus/click when loadFromColor runs)
                var existingName = entry.name != null ? String(entry.name).trim() : "";
                var existingNumber = entry.number != null ? String(entry.number).trim() : "";
                if (nameVal === "" && existingName !== "") nameVal = existingName;
                if (numVal === "" && existingNumber !== "") numVal = existingNumber;
                return Object.assign({}, entry, {
                    id: rowId,
                    name: nameVal,
                    number: numVal,
                    size: ld.size != null ? ld.size : entry.size,
                    visible: ld.visible !== undefined ? ld.visible : true,
                    numberUserEdited: ld.numberUserEdited ? true : (entry.numberUserEdited === true)
                });
            });
            for (var j = existingList.length; j < loaded.length; j++) {
                var ld = loaded[j];
                var rowId = ld.id != null ? ld.id : j + 1;
                var numVal = getNumVal(ld, j);
                result.push({
                    id: rowId,
                    name: (ld.name != null ? ld.name : "").toString().trim(),
                    number: numVal,
                    size: ld.size != null ? ld.size : "",
                    visible: ld.visible !== undefined ? ld.visible : true,
                    numberUserEdited: ld.numberUserEdited ? true : false
                });
            }
            if (loaded.length < result.length) {
                result = result.slice(0, loaded.length);
            }
            return result;
        },
        saveViewToColor(view) {
            view = view || this.activeView;
            var idx = localStorage.getItem("colorIndex");
            var group =
                this.genderGroupsItems &&
                this.genderGroupsItems[this.activeGenderKey];
            var color = group && group.colors && group.colors[idx];
            if (!color) {
                return;
            }

            if (!color.selected_name_number)
                color.selected_name_number = {
                    front: { name: false, number: false },
                    back: { name: false, number: false },
                    left: { name: false, number: false },
                    right: { name: false, number: false }
                };
            if (!color.view_settings)
                color.view_settings = {
                    front: {},
                    back: {},
                    left: {},
                    right: {}
                };

            var vs = this.viewStates[view];
            color.selected_name_number[view] = {
                name: vs.addName,
                number: vs.addNumber
            };
            // One shared table: save single array for all locations; embed selected_name_number in same JSON (no extra column)
            var entriesArr = (vs.entries && vs.entries.length)
                ? JSON.parse(JSON.stringify(vs.entries))
                : [];
            var selectedNameNumber = {
                front: { name: !!this.viewStates.front.addName, number: !!this.viewStates.front.addNumber },
                back: { name: !!this.viewStates.back.addName, number: !!this.viewStates.back.addNumber },
                left: { name: !!this.viewStates.left.addName, number: !!this.viewStates.left.addNumber },
                right: { name: !!this.viewStates.right.addName, number: !!this.viewStates.right.addNumber }
            };
            color.selected_name_number = selectedNameNumber;
            color.name_and_number_json = {
                front: entriesArr,
                back: entriesArr,
                left: entriesArr,
                right: entriesArr,
                selected_name_number: selectedNameNumber
            };
            // One shared styling: same settings for all views
            var sharedNameSettings = Object.assign({}, vs.nameSettings);
            var sharedNumberSettings = Object.assign({}, vs.numberSettings);
            ["front", "back", "left", "right"].forEach(function (v) {
                color.view_settings[v] = {
                    nameSettings: sharedNameSettings,
                    numberSettings: sharedNumberSettings
                };
            });
            color.font_color_sizes_name = {
                nameFontFamily: vs.nameSettings.fontFamily,
                nameFontColor: vs.nameSettings.fontColor,
                nameFontSize: vs.nameSettings.fontSize,
                color_id: vs.nameSettings.colorId,
                decor_upcharge: vs.nameSettings.decor_upcharge
            };
            color.font_color_sizes_number = {
                numberFontFamily: vs.numberSettings.fontFamily,
                numberFontColor: vs.numberSettings.fontColor,
                numberFontSize: vs.numberSettings.fontSize,
                color_id: vs.numberSettings.colorId,
                decor_upcharge: vs.numberSettings.decor_upcharge
            };
        },
        saveAllViewsToColor() {
            var _this = this;
            ["front", "back", "left", "right"].forEach(function (v) {
                _this.saveViewToColor(v);
            });
            // All views synced to color -> parent should do full replace of counts, not merge
            this.$emit("updateNameNumberFees");
        },
        countFilledEntries(view, type) {
            var vs = this.viewStates[view];
            if (!vs) return 0;
            var enabled = type === "name" ? vs.addName : vs.addNumber;
            if (!enabled) return 0;
            return (vs.entries || []).filter(function (e) {
                var val = type === "name" ? e.name : e.number;
                return val && val.toString().trim() !== "";
            }).length;
        },
        onAddNameChange(value) {
            this.$set(this.viewStates[this.activeView], "addName", value);
            this.$emit("undoAndRedo");
            if (value) this.addNameToCanvas();
            else this.removeFromCanvas("name");
            this.saveViewToColor();
            this.$emit("updateNameNumberFees", this.activeView);
        },
        onAddNumberChange(value) {
            this.$set(this.viewStates[this.activeView], "addNumber", value);
            this.$emit("undoAndRedo");
            if (value) this.addNumberToCanvas();
            else this.removeFromCanvas("number");
            this.saveViewToColor();
            this.$emit("updateNameNumberFees", this.activeView);
        },
        onNameSettingsChange(settings) {
            var shared = settings;
            ["front", "back", "left", "right"].forEach(function (view) {
                this.$set(this.viewStates[view], "nameSettings", shared);
            }, this);
            if (this.currentViewState.addName) this.updateCanvasObject("name");
            this.saveViewToColor();
            this.$emit("updateNameNumberFees", this.activeView);
        },
        onNumberSettingsChange(settings) {
            var shared = settings;
            ["front", "back", "left", "right"].forEach(function (view) {
                this.$set(this.viewStates[view], "numberSettings", shared);
            }, this);
            if (this.currentViewState.addNumber)
                this.updateCanvasObject("number");
            this.saveViewToColor();
            this.$emit("updateNameNumberFees", this.activeView);
        },
        onEntriesChange(entries) {
            var sharedEntries = entries;
            ["front", "back", "left", "right"].forEach(function (view) {
                this.$set(this.viewStates[view], "entries", sharedEntries);
            }, this);
            this.updateCanvasFromEntries();
        },
        onEntryBlur() {
            this.saveViewToColor();
            this.updateCanvasFromEntries();
            // Common table: refresh counts for all locations so run charge / breakdown update everywhere
            this.$emit("updateNameNumberFees");
        },
        /** Find name/number object on canvas (objType on object or in toObject(); also search inside groups). */
        getCanvasObjectByType(objType) {
            if (!this.canvasActiveObject) return null;
            function findIn(objs) {
                if (!objs || !objs.length) return null;
                for (var i = 0; i < objs.length; i++) {
                    var o = objs[i];
                    var ot = o.objType || (o.toObject && o.toObject().objType);
                    if (ot === objType) return o;
                    if (o.type === "group" && o.getObjects) {
                        var inner = findIn(o.getObjects());
                        if (inner) return inner;
                    }
                }
                return null;
            }
            var list = this.canvasActiveObject.getObjects ? this.canvasActiveObject.getObjects() : [];
            return findIn(list) || null;
        },
        //Returns the "last entered" entry based on what is enabled.
         
        getLastEnteredEntry() {
            var vs = this.currentViewState || {};
            var entries = vs.entries || [];
            var addName = !!vs.addName;
            var addNumber = !!vs.addNumber;
            function hasText(val) {
                return (
                    val !== undefined &&
                    val !== null &&
                    String(val).trim() !== ""
                );
            }
            for (var i = entries.length - 1; i >= 0; i--) {
                var e = entries[i] || {};
                var hasName = addName && hasText(e.name);
                var hasNumber = addNumber && hasText(e.number);
                if (addName && addNumber) {
                    if (hasName || hasNumber) return e;
                } else if (addName) {
                    if (hasName) return e;
                } else if (addNumber) {
                    if (hasNumber) return e;
                }
            }
            return null;
        },
        /** Is location ke liye kaunsi entry dikhani hai: eye se set row ya last entered. Har location alag. */
        getEntryForPreview() {
            var vs = this.currentViewState || {};
            var entries = vs.entries || [];
            var view = this.activeView || "front";
            var idx = this.previewEntryIndexByView && this.previewEntryIndexByView[view];
            if (idx != null && idx >= 0 && idx < entries.length) {
                var e = entries[idx] || {};
                var addName = !!vs.addName;
                var addNumber = !!vs.addNumber;
                var hasName = addName && e.name != null && String(e.name).trim() !== "";
                var hasNumber = addNumber && e.number != null && String(e.number).trim() !== "";
                if (addName && addNumber && (hasName || hasNumber)) return e;
                if (addName && hasName) return e;
                if (addNumber && hasNumber) return e;
            }
            return this.getLastEnteredEntry();
        },
        getPreviewName(hidePlaceholder) {
            var vs = this.currentViewState || {};
            if (!vs.addName) return "";

            var entry = this.getEntryForPreview();
            if (entry) {
                return entry.name != null ? String(entry.name).trim() : "";
            }
            return hidePlaceholder ? "" : "YOUR NAME";
        },
        getPreviewNumber(hidePlaceholder) {
            var vs = this.currentViewState || {};
            if (!vs.addNumber) return "";

            var entry = this.getEntryForPreview();
            if (entry) {
                return entry.number != null ? String(entry.number).trim() : "";
            }
            return hidePlaceholder ? "" : "00";
        },
        updateCanvasFromEntries(skipPlaceholders) {
            if (!this.canvasActiveObject) return;
            var view = this.activeView;
            var nameObjType = "name_" + view;
            var numberObjType = "number_" + view;
            var objs = this.canvasActiveObject.getObjects();
            var nameObj = objs.find(function (o) {
                return (o.toObject && o.toObject().objType) === nameObjType;
            });
            var numberObj = objs.find(function (o) {
                return (o.toObject && o.toObject().objType) === numberObjType;
            });
            // Never set empty text on canvas when name/number is enabled - use placeholders so stretch layout doesn't break
            var nameText = this.getPreviewName(skipPlaceholders);
            if (nameText === "" && this.currentViewState.addName) nameText = "YOUR NAME";
            var numberText = this.getPreviewNumber(skipPlaceholders);
            if (numberText === "" && this.currentViewState.addNumber) numberText = "00";
            if (nameObj && nameObj.type === "text") {
                nameObj.set("text", nameText);
                if (this.designBox) nameObj.set("clipPath", this.designBox);
                nameObj.setCoords();
            }
            if (numberObj && numberObj.type === "text") {
                numberObj.set("text", numberText);
                if (this.designBox) numberObj.set("clipPath", this.designBox);
                numberObj.setCoords();
            }
            this.canvasActiveObject.renderAll();
        },
        /** Preview a single row's name/number on design area (eye button). Sirf is location ke liye set. */
        previewEntryOnCanvas(entryIndex) {
            if (!this.canvasActiveObject) return;
            var entries = this.currentViewState.entries || [];
            var entry = entries[entryIndex];
            if (!entry) return;
            var view = this.activeView;
            // Save current row's position/size before switching (har row ka apna view preserve)
            var currentEntryIdx = this.previewEntryIndexByView && this.previewEntryIndexByView[view];
            if (currentEntryIdx != null && currentEntryIdx !== entryIndex) {
                this.saveCurrentEntryPositionToView(view, currentEntryIdx);
            }
            this.$set(this.previewEntryIndexByView, this.activeView, entryIndex);
            var addName = this.currentViewState.addName;
            var addNumber = this.currentViewState.addNumber;
            var nameText = (addName && entry.name != null && String(entry.name).trim() !== "")
                ? String(entry.name).trim()
                : "";
            var numberText = (addNumber && entry.number != null && String(entry.number).trim() !== "")
                ? String(entry.number).trim()
                : "";
            var nameObj = this.getCanvasObjectByType("name_" + view);
            var numberObj = this.getCanvasObjectByType("number_" + view);
            var nameSettings = this.currentViewState.nameSettings;
            var numberSettings = this.currentViewState.numberSettings;
            if (nameObj && nameObj.type === "text") {
                nameObj.set("text", nameText || "");
                nameObj.set("fontFamily", nameSettings.fontFamily || "Verdana");
                nameObj.set("fontSize", parseInt(nameSettings.fontSize, 10) || 21);
                nameObj.set("fill", nameSettings.fontColor || "#000000");
                if (this.designBox) nameObj.set("clipPath", this.designBox);
                nameObj.setCoords();
            }
            if (numberObj && numberObj.type === "text") {
                numberObj.set("text", numberText || "");
                numberObj.set("fontFamily", numberSettings.fontFamily || "Verdana");
                numberObj.set("fontSize", parseInt(numberSettings.fontSize, 10) || 96);
                numberObj.set("fill", numberSettings.fontColor || "#000000");
                if (this.designBox) numberObj.set("clipPath", this.designBox);
                numberObj.setCoords();
            }
            // Remove name/number from canvas when this entry has no text for them - avoids stretched/empty box when only one is filled
            if (nameText === "" && nameObj) {
                this.removeFromCanvas("name", view);
                nameObj = null;
            }
            if (numberText === "" && numberObj) {
                this.removeFromCanvas("number", view);
                numberObj = null;
            }
            // If user had deleted name/number from canvas (cross), re-add when they click Show (eye). Only add if this entry has that content.
            if (addName && nameText !== "" && !nameObj) {
                this.addNameToCanvas();
            }
            if (addNumber && numberText !== "" && !numberObj) {
                this.addNumberToCanvas();
            }
            // Restore this row's saved position/size on existing objects (har row ka apna position+resize apply)
            var byEntry = this.nameNumberPositionByView && this.nameNumberPositionByView[view] && this.nameNumberPositionByView[view].byEntry;
            var savedForEntry = byEntry && byEntry[entryIndex];
            nameObj = this.getCanvasObjectByType("name_" + view);
            numberObj = this.getCanvasObjectByType("number_" + view);
            if (savedForEntry) {
                if (savedForEntry.name && nameObj) {
                    var sn = savedForEntry.name;
                    nameObj.set({
                        left: typeof sn.left === "number" ? sn.left : nameObj.left,
                        top: typeof sn.top === "number" ? sn.top : nameObj.top,
                        scaleX: typeof sn.scaleX === "number" && sn.scaleX > 0 ? sn.scaleX : 1,
                        scaleY: typeof sn.scaleY === "number" && sn.scaleY > 0 ? sn.scaleY : 1,
                        angle: typeof sn.angle === "number" ? sn.angle : 0
                    });
                    nameObj.setCoords();
                }
                if (savedForEntry.number && numberObj) {
                    var snum = savedForEntry.number;
                    numberObj.set({
                        left: typeof snum.left === "number" ? snum.left : numberObj.left,
                        top: typeof snum.top === "number" ? snum.top : numberObj.top,
                        scaleX: typeof snum.scaleX === "number" && snum.scaleX > 0 ? snum.scaleX : 1,
                        scaleY: typeof snum.scaleY === "number" && snum.scaleY > 0 ? snum.scaleY : 1,
                        angle: typeof snum.angle === "number" ? snum.angle : 0
                    });
                    numberObj.setCoords();
                }
            }
            this.canvasActiveObject.renderAll();
        },
        onClearAll() {
            var vs = this.viewStates[this.activeView];
            var cleared = (vs.entries || []).map(function (e) {
                return Object.assign({}, e, { name: "", number: "", numberUserEdited: false });
            });
            var sharedEntries = cleared;
            ["front", "back", "left", "right"].forEach(function (view) {
                this.$set(this.viewStates[view], "entries", sharedEntries);
            }, this);
            // Reset which row is shown on canvas so we don't show "last entry"
            this.previewEntryIndexByView = { front: null, back: null, left: null, right: null };
            // Show default placeholders (YOUR NAME / 00) on canvas; do not remove name/number (checkboxes stay enabled)
            this.updateCanvasFromEntries(false);
            if (this.canvasActiveObject) {
                var view = this.activeView;
                var nameObjType = "name_" + view;
                var numberObjType = "number_" + view;
                var objs = this.canvasActiveObject.getObjects();
                var nameObj = objs.find(function (o) {
                    return (o.toObject && o.toObject().objType) === nameObjType;
                });
                var numberObj = objs.find(function (o) {
                    return (o.toObject && o.toObject().objType) === numberObjType;
                });
                if (this.currentViewState.addName && !nameObj) this.addNameToCanvas();
                if (this.currentViewState.addNumber && !numberObj) this.addNumberToCanvas();
            }
            this.saveViewToColor();
            this.$emit("updateNameNumberFees", this.activeView);
        },
        onSave() {
            this.runCloseCleanup();
            this.$emit("closeMenu", "nn-tab");
        },
        /** Same cleanup as onCloseMenu but without emitting closeMenu. Call when panel is closed by outer click (e.g. switching tab) so unfilled name/number is cleared and placeholders don't stay. */
        runCloseCleanup() {
            if (!this.viewStates) return;
            this.updateCanvasFromEntries(true);
            var _this = this;
            ["front", "back", "left", "right"].forEach(function (v) {
                _this.clearUnfilledNameNumberOnClose(v);
            });
            this.saveAllViewsToColor();
        },
        onCloseMenu(payload) {
            this.runCloseCleanup();
            this.$emit("closeMenu", payload !== undefined ? payload : "nn-tab");
        },
        goToTeamUniform() {
            this.$router.push({ name: "team_uniform" });
        },
        addNameToCanvas() {
            if (!this.canvasActiveObject) {
                return;
            }
            var displayText = this.getPreviewName();
            var objType = "name_" + this.activeView;
            var active = this.getCanvasObjectByType(objType);
            var settings = this.currentViewState.nameSettings;
            if (!active) {
                var entryIdx = this.previewEntryIndexByView && this.previewEntryIndexByView[this.activeView];
                if (entryIdx == null) entryIdx = 0;
                var byEntry = this.nameNumberPositionByView && this.nameNumberPositionByView[this.activeView] && this.nameNumberPositionByView[this.activeView].byEntry;
                var saved = byEntry && byEntry[entryIdx] && byEntry[entryIdx].name;
                var left = saved && typeof saved.left === "number" ? saved.left : parseInt(this.frontCanvasLeft, 10) + 8;
                var top = saved && typeof saved.top === "number" ? saved.top : parseInt(this.frontCanvasTop, 10) + 10;
                var angle = saved && typeof saved.angle === "number" ? saved.angle : 0;
                var scaleX = saved && typeof saved.scaleX === "number" && saved.scaleX > 0 ? saved.scaleX : 1;
                var scaleY = saved && typeof saved.scaleY === "number" && saved.scaleY > 0 ? saved.scaleY : 1;
                var text = new fabric.Text(displayText, {
                    id: objType,
                    left: left,
                    top: top,
                    angle: angle,
                    scaleX: scaleX,
                    scaleY: scaleY,
                    fontFamily: settings.fontFamily || "Verdana",
                    fontWeight: "bold",
                    fill: settings.fontColor || "#000000",
                    fontSize: parseInt(settings.fontSize, 10) || 21,
                    padding: 0,
                    selectable: true,
                    evented: true,
                    hasControls: true
                });
                var toObj = text.toObject;
                text.toObject = function () {
                    return fabric.util.object.extend(toObj.call(this), {
                        objType: objType,
                        products_id: localStorage.getItem("product_id")
                    });
                };
                this.canvasActiveObject.add(text);
                if (!saved) text.centerH();
                if (this.designBox) text.set("clipPath", this.designBox);
            } else if (active.type === "text") {
                active.set({
                    text: displayText,
                    fontFamily: settings.fontFamily || "Verdana",
                    fontSize: parseInt(settings.fontSize, 10) || 21,
                    fill: settings.fontColor || "#000000"
                });
                if (this.designBox) active.set("clipPath", this.designBox);
                active.setCoords();
            }
            this.canvasActiveObject.renderAll();
        },
        addNumberToCanvas() {
            if (!this.canvasActiveObject) {
                return;
            }
            var displayText = this.getPreviewNumber();
            var objType = "number_" + this.activeView;
            var active = this.getCanvasObjectByType(objType);
            var settings = this.currentViewState.numberSettings;
            if (!active) {
                var entryIdx = this.previewEntryIndexByView && this.previewEntryIndexByView[this.activeView];
                if (entryIdx == null) entryIdx = 0;
                var byEntry = this.nameNumberPositionByView && this.nameNumberPositionByView[this.activeView] && this.nameNumberPositionByView[this.activeView].byEntry;
                var saved = byEntry && byEntry[entryIdx] && byEntry[entryIdx].number;
                var left = saved && typeof saved.left === "number" ? saved.left : parseInt(this.frontCanvasLeft, 10) + 85;
                var top = saved && typeof saved.top === "number" ? saved.top : parseInt(this.frontCanvasTop, 10) + 55;
                var angle = saved && typeof saved.angle === "number" ? saved.angle : 0;
                var scaleX = saved && typeof saved.scaleX === "number" && saved.scaleX > 0 ? saved.scaleX : 1;
                var scaleY = saved && typeof saved.scaleY === "number" && saved.scaleY > 0 ? saved.scaleY : 1;
                var text = new fabric.Text(displayText, {
                    id: objType,
                    left: left,
                    top: top,
                    angle: angle,
                    scaleX: scaleX,
                    scaleY: scaleY,
                    fontFamily: settings.fontFamily || "Verdana",
                    fontWeight: "bold",
                    fill: settings.fontColor || "#000000",
                    fontSize: parseInt(settings.fontSize, 10) || 96,
                    padding: 0,
                    selectable: true,
                    evented: true,
                    hasControls: true,
                    originX: "center"
                });
                var toObj = text.toObject;
                text.toObject = function () {
                    return fabric.util.object.extend(toObj.call(this), {
                        objType: objType,
                        products_id: localStorage.getItem("product_id")
                    });
                };
                this.canvasActiveObject.add(text);
                if (!saved) text.centerH();
                if (this.designBox) text.set("clipPath", this.designBox);
            } else if (active.type === "text") {
                active.set({
                    text: displayText,
                    fontFamily: settings.fontFamily || "Verdana",
                    fontSize: parseInt(settings.fontSize, 10) || 96,
                    fill: settings.fontColor || "#000000"
                });
                if (this.designBox) active.set("clipPath", this.designBox);
                active.setCoords();
            }
            this.canvasActiveObject.renderAll();
        },
        updateCanvasObject(type) {
            if (type === "name") this.addNameToCanvas();
            else if (type === "number") this.addNumberToCanvas();
        },
        /** Save current canvas name/number position+scale to given view and entry (before switching row). */
        saveCurrentEntryPositionToView(view, entryIndex) {
            if (!this.canvasActiveObject) return;
            var nameObj = this.getCanvasObjectByType("name_" + view);
            var numberObj = this.getCanvasObjectByType("number_" + view);
            if (!this.nameNumberPositionByView[view]) this.nameNumberPositionByView[view] = { byEntry: {} };
            if (!this.nameNumberPositionByView[view].byEntry) this.nameNumberPositionByView[view].byEntry = {};
            var entryState = Object.assign({}, this.nameNumberPositionByView[view].byEntry[entryIndex] || {});
            if (nameObj) {
                entryState.name = {
                    left: nameObj.left,
                    top: nameObj.top,
                    scaleX: typeof nameObj.scaleX === "number" ? nameObj.scaleX : 1,
                    scaleY: typeof nameObj.scaleY === "number" ? nameObj.scaleY : 1,
                    angle: typeof nameObj.angle === "number" ? nameObj.angle : 0
                };
            }
            if (numberObj) {
                entryState.number = {
                    left: numberObj.left,
                    top: numberObj.top,
                    scaleX: typeof numberObj.scaleX === "number" ? numberObj.scaleX : 1,
                    scaleY: typeof numberObj.scaleY === "number" ? numberObj.scaleY : 1,
                    angle: typeof numberObj.angle === "number" ? numberObj.angle : 0
                };
            }
            this.$set(this.nameNumberPositionByView[view].byEntry, entryIndex, entryState);
        },
        removeFromCanvas(type, view) {
            if (!this.canvasActiveObject) return;
            view = view || this.activeView;
            var active = this.getCanvasObjectByType(type + "_" + view);
            if (active) {
                // Save position + scale + angle per view AND per row (har row ka apna position/size)
                var entryIndex = this.previewEntryIndexByView && this.previewEntryIndexByView[view];
                if (entryIndex == null) entryIndex = 0;
                var pos = {
                    left: active.left,
                    top: active.top,
                    scaleX: typeof active.scaleX === "number" ? active.scaleX : 1,
                    scaleY: typeof active.scaleY === "number" ? active.scaleY : 1,
                    angle: typeof active.angle === "number" ? active.angle : 0
                };
                if (!this.nameNumberPositionByView[view]) this.nameNumberPositionByView[view] = { byEntry: {} };
                if (!this.nameNumberPositionByView[view].byEntry) this.nameNumberPositionByView[view].byEntry = {};
                var entryState = this.nameNumberPositionByView[view].byEntry[entryIndex] || {};
                entryState[type] = pos;
                this.$set(this.nameNumberPositionByView[view].byEntry, entryIndex, entryState);
                this.canvasActiveObject.remove(active);
                this.canvasActiveObject.renderAll();
            }
        },
        clearUnfilledNameNumberOnClose(view) {
            var vs = this.viewStates[view];
            if (!vs || !vs.entries) return;
            var hasName = vs.entries.some(function (e) {
                return e.name != null && String(e.name).trim() !== "";
            });
            var hasNumber = vs.entries.some(function (e) {
                return e.number != null && String(e.number).trim() !== "";
            });
            if (vs.addName && !hasName) {
                this.$set(this.viewStates[view], "addName", false);
                this.removeFromCanvas("name", view);
            }
            if (vs.addNumber && !hasNumber) {
                this.$set(this.viewStates[view], "addNumber", false);
                this.removeFromCanvas("number", view);
            }
        },
        removeSelections() {
            var _this = this;
            ["front", "back", "left", "right"].forEach(function (view) {
                _this.$set(_this.viewStates[view], "addName", false);
                _this.$set(_this.viewStates[view], "addNumber", false);
            });
            this.saveAllViewsToColor();
        },
        disableName() {
            this.number_sizes_list = [
                { pixel_val: 40, size_number: 2 },
                { pixel_val: 56, size_number: 3 },
                { pixel_val: 64, size_number: 4 },
                { pixel_val: 96, size_number: 6 }
            ];
        },
        enableName() {
            this.number_sizes_list = [
                { pixel_val: 40, size_number: 2 },
                { pixel_val: 56, size_number: 3 },
                { pixel_val: 64, size_number: 4 },
                { pixel_val: 96, size_number: 6 },
                { pixel_val: 128, size_number: 8 }
            ];
        },
        setColorSizesForName(settings) {
            if (!settings || !this.viewStates[this.activeView]) return;
            var s = this.viewStates[this.activeView].nameSettings;
            if (settings.nameFontFamily) s.fontFamily = settings.nameFontFamily;
            if (settings.nameFontColor) s.fontColor = settings.nameFontColor;
            if (settings.nameFontSize) s.fontSize = settings.nameFontSize;
            if (settings.color_id) s.colorId = settings.color_id;
            if (settings.decor_upcharge !== undefined)
                s.decor_upcharge = settings.decor_upcharge;
        },
        setColorSizesForNumber(settings) {
            if (!settings || !this.viewStates[this.activeView]) return;
            var s = this.viewStates[this.activeView].numberSettings;
            if (settings.numberFontFamily)
                s.fontFamily = settings.numberFontFamily;
            if (settings.numberFontColor)
                s.fontColor = settings.numberFontColor;
            if (settings.numberFontSize) s.fontSize = settings.numberFontSize;
            if (settings.color_id) s.colorId = settings.color_id;
            if (settings.decor_upcharge !== undefined)
                s.decor_upcharge = settings.decor_upcharge;
        },
        clearAllEntries() {
            var _this = this;
            var sharedEmpty = [];
            ["front", "back", "left", "right"].forEach(function (view) {
                _this.$set(_this.viewStates[view], "entries", sharedEmpty);
                _this.$set(_this.viewStates[view], "addName", false);
                _this.$set(_this.viewStates[view], "addNumber", false);
            });
        },
        getViewStates() {
            return this.viewStates;
        },
        getCounts() {
            return {
                front: {
                    name: this.frontNameCount,
                    number: this.frontNumberCount
                },
                back: {
                    name: this.backNameCount,
                    number: this.backNumberCount
                },
                left: {
                    name: this.leftNameCount,
                    number: this.leftNumberCount
                },
                right: {
                    name: this.rightNameCount,
                    number: this.rightNumberCount
                },
                totalNames: this.totalNamesCount,
                totalNumbers: this.totalNumbersCount
            };
        }
    },
    beforeDestroy() {
        if (this._canvasWatcher) clearInterval(this._canvasWatcher);
    }
};
</script>

<style scoped>
.name-number-container {
    min-height: 200px;
}
.styling-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 12px;
}
.styling-title {
    margin: 0;
    flex: 1;
}
.close-btn {
    background: none !important;
    border: none !important;
    padding: 4px;
    cursor: pointer;
    flex-shrink: 0;
}
.close-btn img {
    display: block;
    width: 14px;
    height: 14px;
}


.table-footer {
    margin-top: 12px;
}
.total-info {
    font-size: 0.9rem;
    margin-bottom: 8px;
}
.size-breakdown {
    color: #666;
    margin-left: 8px;
}
.action-buttons {
    display: flex;
    gap: 12px;
    margin-bottom: 12px;
}
.btn-team-uniform,
.btn-save {
    min-width: 150px;
    height: 40px;
    padding: 0 20px;
    border-radius: 3px;
    font-size: 0.85rem;
    font-weight: 600;
    cursor: pointer;
    border: 1px solid transparent;
    text-transform: uppercase;
    letter-spacing: 0.04em;
    width: 100%;
    height: 48px;

}
.btn-team-uniform {
    background: #ffffff;
    border-color: #0079c1 !important;
    color: #0079c1;
    font-weight: 400;
}
.btn-save {
    background: #f2790c !important;
    border-color: #f2790c !important;
    color: #ffffff !important;
}
.helper-text {
    font-size: 12px;
    line-height: 18px;
    color: #121212;
    font-weight: 400;
}
.helper-text ul {
    margin: 0;
    padding-left: 18px;
}
.total-label {
    font-weight: bold;
}
.cell-number{
    flex: 0.3 0 48px;
}
.cell-name{
    flex: 0.6 0 48px;
}
.cell-size{
    flex: 0.2 0 36px;
}
</style>
